import { render, staticRenderFns } from "./sosrecord.vue?vue&type=template&id=7fb346e4&scoped=true&"
import script from "./sosrecord.vue?vue&type=script&lang=js&"
export * from "./sosrecord.vue?vue&type=script&lang=js&"
import style0 from "./sosrecord.vue?vue&type=style&index=0&id=7fb346e4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb346e4",
  null
  
)

export default component.exports